// QR 미리보기·다운로드 — 인증이 필요한 엔드포인트라 blob으로 받아 표시한다
import { useEffect, useState } from "react";
import { fetchQrObjectUrl } from "../api/links.ts";

interface Props {
  shortKey: string;
  shortUrl: string;
  onClose: () => void;
}

export function QrDialog({ shortKey, shortUrl, onClose }: Props) {
  const [pngUrl, setPngUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    fetchQrObjectUrl(shortKey, "PNG", 320)
      .then((url) => {
        if (cancelled) {
          URL.revokeObjectURL(url);
          return;
        }
        objectUrl = url;
        setPngUrl(url);
      })
      .catch(() => setError("QR 이미지를 불러오지 못했습니다."));

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl); // 메모리 누수 방지
    };
  }, [shortKey]);

  /** 인쇄용은 벡터(SVG)가 적합하다 */
  const download = async (format: "PNG" | "SVG") => {
    try {
      const url = await fetchQrObjectUrl(shortKey, format, 1024);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `taplink-${shortKey}.${format.toLowerCase()}`;
      anchor.click();
      URL.revokeObjectURL(url);
    } catch {
      setError("다운로드에 실패했습니다.");
    }
  };

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qr-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="qr-title">QR 코드</h2>
        <p className="hint">{shortUrl}</p>

        {error && <div className="alert alert-error" role="alert">{error}</div>}

        <div className="qr-preview">
          {pngUrl ? (
            <img src={pngUrl} alt={`${shortUrl} QR 코드`} width={240} height={240} />
          ) : (
            <p role="status">불러오는 중…</p>
          )}
        </div>

        {/* 두 저장 버튼은 이 레이어의 **목적**이다 — 중립 회색으로 두면 닫기와
            무게가 같아 보인다. 윤곽선 기본색으로 올려 "이걸 하러 왔다"를 보이게 하고,
            채운 기본색(닫기)과는 여전히 한 단 낮은 무게로 남긴다. */}
        <div className="row-actions">
          <button type="button" className="btn-outline-primary" onClick={() => void download("PNG")}>
            PNG 저장
          </button>
          <button type="button" className="btn-outline-primary" onClick={() => void download("SVG")}>
            SVG 저장 (인쇄용)
          </button>
        </div>

        {/* 인라인 marginTop 을 .modal-close 로 옮겼다 — 통계 레이어와 같은 규칙을 봐야
            둘이 갈라지지 않는다. .btn-block 도 그 안에 들어 있다. */}
        <button type="button" className="btn-primary modal-close" onClick={onClose}>
          닫기
        </button>
      </div>
    </div>
  );
}
